import { ProductServiceCategoryGqlOutput } from 'zma-react-sdk/product-service'

export const flattenCategory = (
  categories: ProductServiceCategoryGqlOutput[],
  level: number = 0
): Array<ProductServiceCategoryGqlOutput & { level: number }> => {
  const result: Array<ProductServiceCategoryGqlOutput & { level: number }> = []
  for (const category of categories) {
    result.push({ ...category, level })
    if (category.children && category.children.length > 0) {
      result.push(...flattenCategory(category.children, level + 1))
    }
  }
  return result
}
